var render, staticRenderFns
import script from "./download-catalog-button.vue?vue&type=script&lang=ts"
export * from "./download-catalog-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports